import { reduxKey } from './constants';
import { initialize, requestFailure, requestSuccess } from './actionCreators';
import { BirthdayPopupStoreSlice, BirthdayPopupStoreState } from './types';

const defaultState = {
  isLoading: true,
  isInitialized: false,
  isError: false,
};

const actionHandlers = {
  [initialize.toString()]: (state: BirthdayPopupStoreState, action) => ({
    ...state,
    isLoading: true,
    isInitialized: false,
    isError: false,
  }),

  [requestFailure.toString()]: (state: BirthdayPopupStoreState, action) => ({
    ...state,
    isLoading: false,
    isError: true,
    isInitialized: true,
  }),

  [requestSuccess.toString()](
    state: BirthdayPopupStoreSlice,
    { payload }
  ): BirthdayPopupStoreSlice {
    return {
      ...state,
      isLoading: false,
      isInitialized: true,
      data: payload.data,
    };
  },
};

const reducers = {
  [reduxKey as string]: (state = defaultState, action) => {
    if (!actionHandlers[action.type]) {
      return state;
    }
    return actionHandlers[action.type](state, action) || state;
  },
};

export default reducers;
